// `ui` bundles `lib` code for the browser, so this enum (a runtime value, not
// just a type) must resolve through the browser-safe generated entrypoint,
// not the full (Node-only) client.
import { LeadTimeFormat } from '@prisma-client-browser';

export const LEAD_TIME_FORMAT_OPTIONS = [
  { label: 'Lead Time (Weeks)', value: LeadTimeFormat.NUMBER },
  { label: 'Lead Time Notes', value: LeadTimeFormat.TEXT },
  { label: 'Both', value: LeadTimeFormat.BOTH },
];
